export default __webpack_public_path__ + "static/media/delivered_true.30b955fb.svg";